<template>
    <div class="py-8 px-12">
        <div class="d-flex">
            <div class="mr-3" style="padding-right:2px; height: 40px; width: 1px; background-color: black;" ></div>
            <div class="fs-24 fw-600 border-left " style="white-space: nowrap">{{ title }}</div>
        </div>
        <div class="fs-20 fw-300 mt-1">{{ description }}</div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: undefined,
        },
        description: {
            type: String,
            default: undefined,
        }
    }

}
</script>
